import IconButton from "@pathwright/ui/src/components/button/IconButton"
import DropdownItem from "@pathwright/ui/src/components/dropdown/DropdownItem"
import DropdownMenu from "@pathwright/ui/src/components/dropdown/DropdownMenu"
import DropdownTrigger from "@pathwright/ui/src/components/dropdown/DropdownTrigger"
import Screensize from "@pathwright/ui/src/components/ui/Screensize"
import PropTypes from "prop-types"
import styled from "styled-components"
import { getPathItemSettingsUrl } from "../../utils/urls"
import ResourceContext from "../ResourceContext"
import ControlButton from "../ui/ControlButton"
import { useEditPathContext } from "./EditPath"
import EditPathDeleteItem from "./EditPathDeleteItem"

const Row = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  align-items: center;
`

const EditPathItemControls = ({ pathItem, inverted, dragHandleProps }) => {
  const { setEditingId, setArchivingId } = useEditPathContext()
  return (
    <ResourceContext.Consumer>
      {({ resource, group }) => {
        const buttonProps = {
          inverted: inverted,
          styleType: "blank"
        }
        const editProps = {
          label: "Edit",
          icon: "edit",
          onClick: () => setEditingId(pathItem.id)
        }
        const settingsProps = {
          label: "Settings",
          icon: "gear",
          to: getPathItemSettingsUrl(resource.slug, group.id, pathItem.id)
        }
        const deleteProps = {
          label: "Delete",
          icon: "trash",
          onClick: () => setArchivingId(pathItem.id)
        }

        return (
          <>
            <Screensize.Consumer>
              {(screensize) =>
                screensize === "sm" ? (
                  <Row>
                    <DropdownTrigger
                      renderDropdown={() => (
                        <DropdownMenu closeOnClick>
                          <DropdownItem {...settingsProps} />
                          <DropdownItem {...deleteProps} />
                        </DropdownMenu>
                      )}
                    >
                      <IconButton {...buttonProps} icon="ellipses-horizontal" />
                    </DropdownTrigger>
                  </Row>
                ) : (
                  <Row>
                    {/* <ControlButton
                  {...buttonProps}
                  label="Reorder"
                  icon="arrow-double-vertical-2"
                  href="javascript:void()" // can drag <a> but not <button>
                  {...dragHandleProps}
                /> */}
                    {pathItem.type !== "resource" && (
                      <ControlButton {...buttonProps} {...editProps} />
                    )}
                    {/* {pathItem.type !== "lesson" && (
                  <ControlButton {...buttonProps} {...settingsProps} />
                )} */}
                    <ControlButton {...buttonProps} {...deleteProps} />
                  </Row>
                )
              }
            </Screensize.Consumer>
            <EditPathDeleteItem pathItem={pathItem} />
          </>
        )
      }}
    </ResourceContext.Consumer>
  )
}

EditPathItemControls.displayName = "EditPathItemControls"

EditPathItemControls.propTypes = {
  pathItem: PropTypes.object.isRequired,
  dragHandleProps: PropTypes.object,
  inverted: PropTypes.bool
}

export default EditPathItemControls
